<template>
  <div>
    <label class="block text-sm font-semibold leading-6 text-gray-900 mb-2">
      <slot name="label" />
    </label>
    <div class="relative rounded-md shadow-sm">
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
      >
        <ChevronUpDownIcon class="h-4 inline" />
      </div>
      <select
        id="countries"
        ref="selectTemplateRef"
        :value="modelValue"
        class="appearance-none bg-white block w-full rounded-md border-0 py-2.5 pl-4 pr-9 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-300 sm:text-sm sm:leading-6"
        v-bind="$attrs"
        @click="$emit('click')"
        @change="$emit('update:modelValue', $event.target.value)"
      >
        <option disabled selected value="">
          <slot name="placeholder">Please select one</slot>
        </option>
        <option v-for="option in options" :value="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>
    <div v-if="hasErrors" class="text-red-500">
      <div v-for="error of errors" :key="error.$uid" class="input-errors">
        <div class="error-msg">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-1.5 text-slate-500 text-sm">
      <slot name="assistance" />
    </div>
  </div>
</template>
<script lang="ts">
// use normal <script> to declare options
export default {
  inheritAttrs: false,
}
</script>
<script lang="ts" setup>
import { ChevronUpDownIcon } from '@heroicons/vue/24/outline'

const props = defineProps<{
  modelValue?: string | number | null
  options?: { label: string | number; value: string | number | null }[]
  errors?: any[]
}>()
const selectTemplateRef = ref()
defineExpose({
  selectTemplateRef,
})
const hasErrors = computed(() => Boolean(props.errors?.length > 0))
</script>
